(function () {
  function initPicker(root) {
    const variantsEl = root.querySelector("[data-variants-json]");
    const variantIdInput = root.querySelector("[data-card-variant-id]");
    const form = root.querySelector('form[action^="/cart/add"]') || root.querySelector("form");
    if (!variantsEl || !variantIdInput || !form) return;

    const variants = JSON.parse(variantsEl.textContent || "[]");

    function getSelectedOptions() {
      const groups = root.querySelectorAll("[data-option-index]");
      const selected = [];
      groups.forEach((group) => {
        const idx = parseInt(group.getAttribute("data-option-index"), 10);
        const checked = group.querySelector('input[type="radio"]:checked');
        selected[idx] = checked ? checked.value : null;
      });
      return selected;
    }

    function findVariant(options) {
      return variants.find((v) => {
        if (!v || !v.options) return false;
        for (let i = 0; i < options.length; i++) {
          if (options[i] && v.options[i] !== options[i]) return false;
        }
        return true;
      });
    }

    function sync() {
      const selected = getSelectedOptions();
      let match = findVariant(selected);
      if (!match) match = variants.find((v) => v.available) || variants[0];
      if (!match) return;

      variantIdInput.value = match.id;

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = !match.available;
        const label = btn.querySelector("span");
        if (label) label.textContent = match.available ? "Add to cart" : "Sold out";
      }
    }

    root.addEventListener("change", (e) => {
      if (e.target && e.target.matches('input[type="radio"]')) sync();
    });

    sync();
  }

  function initAll() {
    document.querySelectorAll("[data-card-variant-picker]").forEach(initPicker);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
